var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$tvaMq],style:({
    backgroundImage: _vm.backGroundColor,
  }),attrs:{"id":"app","version":_vm.version}},[[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.params.path})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }